import { DownloadObj } from "scrivito/Objs/Download/DownloadObjClass"
import { AttachmentTypename } from "shared/types/Attachment"
import { AttachmentType } from "shared/types/__generated__/graphql"

import { getProductInformationImport } from "./getProductInformationImport"

export function getProductInformationFiles({
  productType,
  parentProductType
}: {
  productType: string
  parentProductType?: string
}): AttachmentType[] | undefined {
  const importObj = getProductInformationImport({
    productType,
    parentProductType
  })
  const docs = importObj?.get("technicalDocumentation") as
    | DownloadObj[]
    | undefined
  if (!docs || docs.length === 0) return undefined
  return docs.map(doc => ({
    id: doc.id(),
    name: doc.get("title") as string,
    fileName: doc.get("title") as string,
    readUrl: doc.contentUrl(),
    __typename: AttachmentTypename
  }))
}
